import React from "react";

import styled from "@emotion/styled";

import Headline from "../../NewHeadline";
import { iProductPackage } from "../../Workshop/store";
import WorkshopProductPackageItem from "../../Workshop/WorkshopProductPackageItem";

const Container = styled.div`
    ${({ theme }) => theme.paddings.containerOuter.left}
    ${({ theme }) => theme.paddings.containerOuter.right}
`;

const ProductContainer = styled.div`
    display: flex;
    flex-flow: row wrap;
    gap: 40px;
    justify-content: space-between;
    margin-top: 40px;
`;

interface iProps {
    headline: string;
    contactFormId?: string;
    productPackages: iProductPackage[];
}

const WorkshopProductPackages = ({
    headline,
    contactFormId,
    productPackages,
}: iProps) => {
    return (
        <Container>
            {headline && <Headline is="2">{headline}</Headline>}
            <ProductContainer>
                {productPackages.map((productPackage, index) => (
                    <WorkshopProductPackageItem
                        key={index}
                        productPackage={productPackage}
                        contactFormId={contactFormId}
                    />
                ))}
            </ProductContainer>
        </Container>
    );
};

export default WorkshopProductPackages;
